module.exports = __webpack_public_path__ + "img/cases-brand-tommee-4.410fc050.jpg";